import { useEffect, useState } from 'react';

/**
 * True at and above Tailwind's `lg` breakpoint (1024px), where the desktop
 * sidebar appears and the mobile tab bar hides. Pages use this to swap the
 * phone-first screen for its desktop workspace without touching the phone code.
 */
export const DESKTOP_QUERY = '(min-width: 1024px)';

export const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(
    () => typeof window !== 'undefined' && window.matchMedia(DESKTOP_QUERY).matches
  );

  useEffect(() => {
    const mq = window.matchMedia(DESKTOP_QUERY);
    const onChange = (e: MediaQueryListEvent) => setIsDesktop(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  return isDesktop;
};
